module.exports = __webpack_public_path__ + "img/ale-bot.2179aa10.png";